import { __assign } from "tslib";
import { legendSettings, widgetSettings } from '../../widget-settings';
export var choroplethLegendSettings = __assign(__assign({}, legendSettings), { layout: 'vertical', position: 'left' });
export var choroplethWidgetSettings = __assign(__assign({}, widgetSettings), { legend: choroplethLegendSettings });
